import Layout from 'components/template/Layout';
import { useAppContext } from 'provider/AppProvider/AppProvider';
import { useNavigate } from 'react-router-dom';
import {
  useGetUserDataByUsername,
  useDefaultColorValue,
} from 'services/queries/app';
import Loader from 'components/modules/Loader';
import { useUserContext } from 'provider/UserProvider/UserProvider';
import Card, { Container } from 'components/modules/Topics';
import Subhead from 'components/modules/Subhead';
import { useGetCategories } from '../../services/queries/category';

interface ICategory {
  id: string;
  name: string;
  image_url?: string;
  content_type: string;
  sort_order: number;
  type: string;
}

const AllCategory = () => {
  useGetUserDataByUsername();
  const {
    about: { platform_version },
    baseURL,
    uuid,
  } = useAppContext();
  const navigate = useNavigate();
  const { loggedInUser } = useUserContext();
  const colors = useDefaultColorValue();

  const { status, data } = useGetCategories({
    uuid: uuid as string,
    token: String(loggedInUser?.id_token),
  });

  if (parseFloat(platform_version) < 10.0) {
    navigate(String(baseURL));
  }

  if (status === 'loading') {
    return (
      <Layout>
        <Loader />
      </Layout>
    );
  }

  const sortedContent = [...(data ?? [])].sort(
    (a, b) => a.sort_order - b.sort_order,
  );

  return (
    <Layout>
      <div style={{ background: colors.light }} className="h-full">
        <div className="mx-auto container py-6 flex flex-col gap-8">
          <Subhead
            backButtonHoverColor={colors.dark}
            backButtonColor={colors.medium}
            titleFontSize="2.25rem"
            title="categories"
            activeBreadcrumbColor={colors.grey}
            breadcrumbColor={colors.dark_blue}
            breadcrumbFontSize="1rem"
          />
          {sortedContent.length === 0 && (
            <div className="text-2xl text-gray-400 grow flex items-center justify-center">
              No Category found.
            </div>
          )}
          <Container>
            {sortedContent.map((item: ICategory) => (
              <div
                key={item.id}
                className="w-auto md:w-[240px] basis-5/12 md:basis-auto md:px-0 flex"
              >
                <Card
                  label={item.name}
                  imgSrc={item.image_url ?? ''}
                  subTitle={item.content_type}
                  targetUrl={`${String(baseURL)}/category/${item.id}`}
                />
              </div>
            ))}
          </Container>
        </div>
      </div>
    </Layout>
  );
};

export default AllCategory;
